import { z } from 'zod'

export const PackageTicketStatusDtoSchema = z.union([z.literal('Active'), z.literal('Inactive')])

export type PackageTicketStatusDto = z.infer<typeof PackageTicketStatusDtoSchema>
